.button-align-bottom-right{display:flex;flex-direction:row;align-content:center;align-items:flex-end;justify-content:flex-end}.container{background-color:#e8efcd!important}
/*# sourceMappingURL=page-title.component-32ATFERC.css.map */
